import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=06826c73&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=06826c73&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06826c73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06826c73')) {
      api.createRecord('06826c73', component.options)
    } else {
      api.reload('06826c73', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=06826c73&scoped=true", function () {
      api.rerender('06826c73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/icon/Detail.vue"
export default component.exports